import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconDownload: FC<IconSVGProps> = ({ color, ...props }) => (
  <IconSVG className="IconDoc" {...props}>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.78906 1.8457C8.68359 1.95117 8.63086 2.0918 8.63086 2.25L8.63086 10.2656L6.5918 8.22656C6.48633 8.12109 6.3457 8.06836 6.1875 8.06836C6.0293 8.06836 5.90625 8.12109 5.7832 8.24414C5.67773 8.34961 5.625 8.47266 5.625 8.63086C5.625 8.78906 5.67773 8.91211 5.80078 9.03516L9.21094 12.3574L12.6211 9.03516C12.7266 8.91211 12.7793 8.78906 12.7793 8.63086C12.7793 8.47266 12.7266 8.34961 12.6211 8.22656C12.5684 8.17383 12.498 8.13867 12.4277 8.12109C12.3574 8.08594 12.2871 8.06836 12.2168 8.06836C12.1465 8.06836 12.0762 8.08594 12.0059 8.12109C11.9355 8.13867 11.8652 8.17383 11.8125 8.22656L9.75586 10.3008L9.75586 2.25C9.75586 2.14453 9.7207 2.05664 9.66797 1.96875C9.61524 1.88086 9.54492 1.81055 9.45703 1.75781C9.36914 1.70508 9.28125 1.6875 9.19336 1.6875C9.03516 1.6875 8.89453 1.74023 8.78906 1.8457Z"
        fill="currentColor"
      />
      <path
        d="M2.25 12.375C2.25 12.0643 1.99816 11.8125 1.6875 11.8125C1.37684 11.8125 1.125 12.0643 1.125 12.375V14.625C1.125 15.2463 1.62868 15.75 2.25 15.75H15.75C16.3713 15.75 16.875 15.2463 16.875 14.625V12.375C16.875 12.0643 16.6232 11.8125 16.3125 11.8125C16.0018 11.8125 15.75 12.0643 15.75 12.375V14.625H2.25V12.375Z"
        fill="currentColor"
      />
    </svg>
  </IconSVG>
)

export default IconDownload
